import React, { useState } from "react";
import { API } from "../App";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { MailCheck, Loader2, ArrowLeft } from "lucide-react";

export const ForgotPasswordForm = ({ initialEmail = "", onBack }) => {
  const [email, setEmail] = useState(initialEmail);
  const [sending, setSending] = useState(false);
  const [sentMsg, setSentMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const r = await fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const d = await r.json();
      if (r.ok) setSentMsg(d.message);
      else toast.error(typeof d.detail === "string" ? d.detail : "Could not send reset email");
    } catch {
      toast.error("Could not send reset email. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const back = (
    <button type="button" onClick={onBack} data-testid="forgot-back-to-login"
      className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-amber-700 transition-colors">
      <ArrowLeft className="w-4 h-4" /> Back to Sign In
    </button>
  );

  if (sentMsg) {
    return (
      <div className="space-y-4 text-center" data-testid="forgot-password-sent">
        <MailCheck className="w-10 h-10 text-green-600 mx-auto" />
        <p className="text-sm text-slate-700">{sentMsg}</p>
        <p className="text-xs text-slate-500">The link expires in 30 minutes. Check your spam folder if it doesn't arrive.</p>
        {back}
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
      <p className="text-sm text-slate-600">Enter your email and we'll send you a link to reset your password.</p>
      <div className="space-y-2">
        <Label htmlFor="forgot-email" className="font-medium text-slate-700">Email Address</Label>
        <Input id="forgot-email" type="email" required value={email} placeholder="manager@construction.com"
          onChange={(e) => setEmail(e.target.value)} className="border-amber-200 focus:border-amber-400"
          data-testid="forgot-email-input" />
      </div>
      <Button type="submit" disabled={sending} className="w-full btn-construction h-11 font-semibold" data-testid="forgot-submit-button">
        {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send Reset Link"}
      </Button>
      <div className="text-center">{back}</div>
    </form>
  );
};
